import React from "react";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { PropsMessageItem } from "./types";
import { getComponent, getContextModules } from "../../../../lib/requireContextHelper";

const context = require.context("./", true, /\.\/Message[a-zA-Z]*\/index.ts/);
const modules = getContextModules(context);

export function getMessageItem(message: Message): React.FC<PropsMessageItem> | null {
  return getComponent(modules, message.details, null);
}
